<form class="search-form" method="post">
    <input type="text" placeholder="Search..." value="">
    <button type="submit" class="search-btn">
        <i class="flaticon-magnifying-glass"></i>
    </button>
</form>